"use client";

import React from "react";

import { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  TextField,
  Typography,
  Paper,
  IconButton,
  Divider,
  Slide,
  InputAdornment,
  alpha,
} from "@mui/material";
import {
  AttachMoney,
  Comment,
  Close,
  CheckCircle,
  ArrowBack,
  Receipt,
} from "@mui/icons-material";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import axios from "axios";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function RefundModal({ open, onClose, orderId, refundAmount }) {
  const [amount, setAmount] = useState(refundAmount);
  const [remark, setRemark] = useState("");
  const [amountError, setAmountError] = useState("");
  const [loading,setLoading] = useState(false)

  const handleAmountChange = (e) => {
    const value = e.target.value;
    if (value && (isNaN(Number(value)) || Number(value) <= 0)) {
      setAmountError("Please enter a valid amount");
    } else if (value <= refundAmount && value > 0) {
      setAmount(value);
      setAmountError('')
      // Validate amount
    } else {
      setAmount(value);
      setAmountError("Amount should be lest than and equal to Paid Amount");
    }
  };

  const handleSubmit = () => {
    if (!amount || isNaN(Number(amount)) || Number(amount) <= 0) {
      setAmountError("Please enter a valid amount");
      return;
    }
    handelSubmit(Number(amount), remark);
  };

  const resetForm = () => {
    setAmount("");
    setRemark("");
    setAmountError("");
  };

  const handelSubmit = (amount, remark) => {
    setLoading(true)
    axios
      .post(process.env.REACT_APP_PATH_BULK + "/products/refundBulkOrder", {
        orderId,
        totalRefund: amount,
        remark: remark,
      })
      .then((res) => {
        if (res.data.success) {
          window.location.reload()
        } else {
          alert(res.data?.message||"Something went wrong")
          setLoading(false)
        }
      })
      .catch((error) => {
        console.log("error");
        alert("Internal Server Error")
        setLoading(false)
      });
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperComponent={Paper}
      TransitionComponent={Transition}
      PaperProps={{
        elevation: 24,
        sx: {
          borderRadius: 3,
          maxWidth: 500,
          width: "100%",
          overflow: "hidden",
          p: 0,
        },
      }}
    >
      {/* Stylish Header */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #4776E6 0%, #8E54E9 100%)",
          color: "white",
          py: 3,
          px: 3,
          position: "relative",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <Receipt sx={{ fontSize: 28, mr: 1.5 }} />
          <Typography variant="h5" fontWeight="600">
            Refund Request
          </Typography>
          <IconButton
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "white",
              bgcolor: "rgba(255,255,255,0.15)",
              "&:hover": {
                bgcolor: "rgba(255,255,255,0.25)",
              },
            }}
            onClick={handleClose}
          >
            <Close />
          </IconButton>
        </Box>
        <Typography
          variant="body2"
          color={"#fff"}
          sx={{ opacity: 0.9, ml: 0.5 }}
        >
          Please fill in the details below to process your refund
        </Typography>
      </Box>

      <DialogContent sx={{ pt: 4, pb: 4, px: 3 }}>
        <Box sx={{ mb: 4 }}>
          <Typography
            variant="subtitle1"
            fontWeight="500"
            sx={{ mb: 1.5, color: "#424242" }}
          >
            Refund Amount
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            value={amount}
            onChange={handleAmountChange}
            error={!!amountError}
            helperText={amountError}
            placeholder="0.00"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <CurrencyRupeeIcon sx={{ color: "#666" }} />
                </InputAdornment>
              ),
              sx: {
                borderRadius: 2,
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: amountError
                    ? "error.main"
                    : alpha("#8E54E9", 0.2),
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: amountError
                    ? "error.main"
                    : alpha("#8E54E9", 0.3),
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: amountError ? "error.main" : "#8E54E9",
                },
                fontSize: "1.1rem",
                py: 0.5,
              },
            }}
          />
        </Box>

        <Divider sx={{ my: 3, opacity: 0.6 }} />

        <Box sx={{ mb: 2 }}>
          <Typography
            variant="subtitle1"
            fontWeight="500"
            sx={{ mb: 1.5, color: "#424242" }}
          >
            Reason for Refund
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
            multiline
            rows={4}
            placeholder="Please provide details about your refund request..."
            InputProps={{
              sx: {
                borderRadius: 2,
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: alpha("#8E54E9", 0.2),
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: alpha("#8E54E9", 0.3),
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#8E54E9",
                },
              },
            }}
          />
        </Box>

        {/* Action Buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 4,
            gap: 2,
          }}
        >
          <Button
            onClick={handleClose}
            variant="outlined"
            startIcon={<ArrowBack />}
            sx={{
              borderRadius: 2,
              py: 1.2,
              px: 3,
              borderColor: alpha("#8E54E9", 0.3),
              color: "#666",
              "&:hover": {
                borderColor: alpha("#8E54E9", 0.5),
                bgcolor: alpha("#8E54E9", 0.05),
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            startIcon={<CheckCircle />}
            disabled={!amount || !!amountError||loading}
            sx={{
              borderRadius: 2,
              py: 1.2,
              px: 3,
              background: "linear-gradient(135deg, #4776E6 0%, #8E54E9 100%)",
              boxShadow: "0 4px 10px rgba(142, 84, 233, 0.3)",
              "&:hover": {
                boxShadow: "0 6px 15px rgba(142, 84, 233, 0.4)",
              },
              "&.Mui-disabled": {
                background: "#e0e0e0",
                color: "#a0a0a0",
              },
            }}
          >
            Submit Refund
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
